/* jshint esversion: 6 */
export default {
  state: {
    userParams: {},
    perms: [] // 用户权限标识集合
  },
  getters: {
    getUserState (state) {
      return state.userParams;
    },
    getUserPerms (state) {
      return state.perms;
    }
  },
  mutations: {
    userState (state, userParams) {
      state.userParams = userParams;
      localStorage.setItem('userParams', JSON.stringify(userParams));
    },
    delUserState (state) {
      state.userParams = '';
      localStorage.removeItem('userParams');
    },
    setPerms (state, perms) { // 用户权限标识集合
      state.perms = perms;
      localStorage.setItem('permission', JSON.stringify(perms));
    }
  },
  actions: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/User.js